export default "__VITE_ASSET__DIglRB55__"